import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthProvider } from '../../utils/auth';
import { AppRoutes } from '../../constants/routes';
import AccountTypeSwitcher from '../AccountTypeSwitcher';

/**
 * Route guard that allows creators, labels, and podcasters to upload podcasts
 * Acts can upload podcasts through their creator accounts
 */
const PodcastUploadRoute = ({ children }) => {
  const { isAuthed, userType, actingAs, isLoading } = useAuthProvider();
  const location = useLocation();

  // Show loading while checking auth status
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        color: 'white'
      }}>
        Loading...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthed) {
    return <Navigate to={AppRoutes.LoginPage} state={{ from: location }} replace />;
  }

  // Allow access for creators, labels, and podcasters
  if (userType === 'creator' || userType === 'podcaster' || actingAs === 'label') {
    return children;
  }

  // Show account type switcher for other user types
  return (
    <AccountTypeSwitcher
      currentUserType={userType}
      targetUserType="creator"
      title="Podcast Upload Access Required"
      message="You need a creator, label, or podcaster account to upload podcasts. Creators can upload podcasts for their artists."
    />
  );
};

export default PodcastUploadRoute;

